/**
 * Renders only the Button
 * @returns {JSX.Element} The basic Button.
 */

import { useState } from 'react';
import Pagination from './Pagination';

const SqlTable = props => {
    const [activePage, setActivePage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalEntries, setTotalEntries] = useState(props.chart?.Data?.length);
    const [totalPages, setTotalPages] = useState(Math.ceil(props.chart?.Data?.length / 10));
    const activeHandler = clickedActive => {
        setActivePage(parseInt(clickedActive));
    };
    return (
        <>
            {props.chart.Data && props.chart.Data.length > 0 && (
                <>
                    {!props.designer?.Settings?.IsListView && (
                        <Pagination
                            active={activePage}
                            size={totalPages}
                            entries={totalEntries}
                            pageSize={pageSize}
                            step={2}
                            onClickHandler={activeHandler}
                            onPageSizeChangeHandler={size => {
                                setPageSize(size);
                                setTotalPages(Math.ceil(props.chart.Data.length / size));
                            }}
                        />
                    )}
                    <div className="mfx-table-container">
                        <table className={'mfx-table'}>
                            <tbody>
                                <tr className="mfx-table-row mfx-table-head">
                                    {Object.entries(props.chart.Data[0]).map(data => {
                                        return (
                                            <th STYLE={data[0].split('\\styling\\')[1]} className={'mfx-table-column-head'}>
                                                {data[0].split('\\styling\\')[0]}
                                            </th>
                                        );
                                    })}
                                </tr>
                                {props.chart.Data.slice((activePage - 1) * pageSize, pageSize * activePage).map(entries => {
                                    return (
                                        <tr className="mfx-table-row mfx-table-head">
                                            {Object.entries(entries).map(data => {
                                                return (
                                                    <td STYLE={data[1].split('\\STYLING\\')[1]} className={'mfx-table-column-head'}>
                                                        {data[1].split('\\STYLING\\')[0]}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            {(!props.chart.Data || props.chart.Data.length === 0) && <h4 className="nothing-found">
                    <div className="success-false extra-small">
                        <div className="icon-style-arrow">
                            <i className="icon-close"></i>
                        </div>
                    </div>
                    {window.Dictionary.getTranslation(5484)}
                </h4>}
        </>
    );
};

export default SqlTable;
